import classNames from 'classnames';

import { InfoTipIcon, RevelioTooltip } from '@revelio/ui';

import styles from './selectable-card.module.css';

interface SelectableCardProps {
  icon: JSX.Element;
  label: string;
  tooltip?: string;
  isSelected?: boolean;
  isDisabled?: boolean;
  onClick?: () => void;
  className?: string;
}

export const SelectableCard = ({
  icon,
  label,
  tooltip,
  isSelected,
  isDisabled,
  onClick,
  className,
}: SelectableCardProps) => {
  const dimmed = isDisabled ? styles.dimmed : undefined;

  return (
    <div
      role="button"
      tabIndex={isDisabled ? undefined : 0}
      onClick={isDisabled ? undefined : onClick}
      onKeyDown={(event) => {
        if (isDisabled || (event.key !== 'Enter' && event.key !== ' ')) return;
        event.preventDefault();
        onClick?.();
      }}
      aria-pressed={isSelected}
      aria-disabled={isDisabled}
      className={classNames(
        styles.card,
        isSelected && styles.selected,
        isDisabled && styles.disabled,
        className
      )}
    >
      <span className={classNames(styles.leading, dimmed)}>{icon}</span>

      <span className={classNames(styles.content, dimmed)}>{label}</span>

      {tooltip && (
        <span className={styles.trailing}>
          <RevelioTooltip label={tooltip} openDelay={300}>
            <InfoTipIcon className={styles.infoTip} />
          </RevelioTooltip>
        </span>
      )}
    </div>
  );
};
